import { Box, Grid } from '@mui/material';
import useAuth from 'hooks/useAuth';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axiosInstance from 'utils/axios';
import AbstractScoringSection from './sections/AbstractScoringSection';

const EventAdminDetail = () => {
    const { id } = useParams();
    const [data, setData] = useState();

    const { user } = useAuth();

    const getData = async () => {
        await axiosInstance
            .get('api/prv/submissions/' + id)
            .then((response) => {
                setData(response.data);
            })
            .catch((err) => console.log(err));
    };

    useEffect(() => {
        if (!user) {
            return;
        }

        getData();
    }, [user]);

    return (
        <>
            {data && (
                <Box pt={2} pb={4}>
                    <AbstractScoringSection data={data} />
                </Box>
            )}
        </>
    );
};

export default EventAdminDetail;
